import React from 'react'
import styled from 'styled-components'
import Box from '../../Components/Box'
import { deviceSize } from '../../utils/constants'

const StyledRelatedProducts = styled(Box)`
    margin-top : 6rem;
    margin-bottom : 3rem;
    overflow : visible;
    .carousel {
        margin : auto;
        width : 90%;
    }

    .title{
        font-size : 1.2vw;
    }

    .newarrival{
        overflow:visible;
    }

    .details{
        width : 100%;
    }
    
    .block-title{
   
        font-size: 32px;
        font-weight: 600;
        line-height: 1;
        margin-bottom: 2.25rem;
        text-align : center;

    }
    
    @media only screen and (max-width : 768px){
        

        iiimg{
            width : 146px;
            min-width:unset;
            height:146px;
        }

        .title{
            font-size : 12px;
           
        }

        .inner-new-prod{
            margin-top : 0rem;
        }
    }

    .categ-title{
        position : relative;
        max-height : 400px;
        width : 100%;
    }

    .section-header{
        justify-content: center ;
    }

    @media only screen and (max-width : ${deviceSize.s}px){
       
        .size{
            min-width : 18px;
            font-size : 10px;
        }
        
        .diat {
            font-size : 10px;
        }

        .categ-title{
            font-size : 120px;
            max-height : 130px;
        }

    }

    

    
`

export default StyledRelatedProducts